import FJCommunityWorkItem from './FJCommunityWorkItem';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import FJActionCommunity from '../../../../redux/action/FJActionCommunity';
import { setSliceMultipleSelectedList } from '../../../../redux/slices/FJSliceCommunity';
import { useMemo, useCallback } from 'react';
const FJCommunityWorkItemContainer = props => {
    const { item, active } = props;
    const multipleSelectedList = useSelector(state => state.community.multipleSelectedList);
    const guestUserInfo = useSelector(state => state.community.guestUserInfo);
    const dispatch = useDispatch();

    const onRecreateClick = () => {
        dispatch(FJActionCommunity.onRecreateClickAction(item, false));
    };
    const onLikeClick = isLike => {
        dispatch(FJActionCommunity.onLikeClickAction(item, isLike));
    };
    const onClick = () => {
        dispatch(FJActionCommunity.onPreviewClickAction(item));
    };

    const onDownloadClick = () => {
        dispatch(FJActionCommunity.multiDownloadAction([item]));
    };
    const onShareSettingClick = (value, callback) => {
        dispatch(FJActionCommunity.onShareSettingClickAction(item, value, callback));
    };
    const onVideoEditClick = () => {
        dispatch(FJActionCommunity.multiVideoEditAction([item]));
    };
    const onDeleteClick = () => {
        dispatch(FJActionCommunity.multiDeleteAction([item.id]));
    };
    const isMultipleSelect = useMemo(() => {
        return multipleSelectedList.length > 0;
    }, [multipleSelectedList]);
    const isSelected = useMemo(() => {
        return multipleSelectedList.includes(item?.id);
    }, [multipleSelectedList, item]);
    const onSelected = useCallback(() => {
        if (!isSelected) {
            dispatch(setSliceMultipleSelectedList([...multipleSelectedList, item?.id]));
        } else {
            dispatch(setSliceMultipleSelectedList(multipleSelectedList.filter(id => id !== item?.id)));
        }
    }, [dispatch, multipleSelectedList, item, isSelected]);
    return (
        <FJCommunityWorkItem
            item={item}
            active={active}
            onRecreateClick={onRecreateClick}
            onLikeClick={onLikeClick}
            onClick={onClick}
            isMultipleSelect={isMultipleSelect}
            isSelected={isSelected}
            onDownloadClick={onDownloadClick}
            onShareSettingClick={onShareSettingClick}
            onVideoEditClick={onVideoEditClick}
            onDeleteClick={onDeleteClick}
            onSelected={onSelected}
            guestUserInfo={guestUserInfo}
        />
    );
};
FJCommunityWorkItemContainer.propTypes = {
    item: PropTypes.object.isRequired,
};
export default FJCommunityWorkItemContainer;
